module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./ExpertsView.js"));
	}, "expertsView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=expertsView!./src/pages/Shop/Formula/Experts/ExpertsView.js
// module id = 920
// module chunks = 431